export const MODEL_STORAGE_KEY = 'tracker_selected_model_id';
